#import "./UserRankFields.graphql"

mutation UserRankCreate($input: UserRankCreateInput!) {
  userRankCreate(input: $input) {
    userRankType {
      ...UserRankFields
    }
  }
}
